import HeaderBackground from '@/components/ui/header-background/header-background';
import { HealthDataEditorHeaderMobile } from './components/health-data-editor-header-mobile';
import { HeaderComponentProps } from '../../types';
import { scrollToCategory } from './utils/scroll-utils';
import { useState } from 'react';
import { HealthDataEditorCard } from './components/health-data-editor-card';
import { HealthDataNavigation } from './components/health-data-navigation';
import { motion } from 'motion/react';
import { useGetHealthData } from '../../use-health-data';

export function HealthDataEditorHeader({
  className = '',
  categories = [],
  categoryModulesRef,
}: HeaderComponentProps) {
  const [activeCategory, setActiveCategory] = useState(categories[0] || '');
  const { isInitiallyFetching } = useGetHealthData();

  const handleCategoryClick = (category: string) => {
    setActiveCategory(category);
    if (categoryModulesRef) {
      scrollToCategory(categoryModulesRef, category);
    }
  };

  return (
    <>
      {/* Mobile Header */}
      <div
        className={`dashboard-reset relative block overflow-hidden bg-[#0a0a0a] md:hidden ${className}`}
        role="region"
        aria-label="Health data editor header"
      >
        <HeaderBackground blur={30} />
        <HealthDataEditorHeaderMobile />
        {/* Rendering outside of card to enable overflow of scrollable nav buttons */}
        <motion.div
          className="w-full pb-6"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <HealthDataNavigation
            categories={categories}
            activeCategory={activeCategory}
            onCategoryClick={handleCategoryClick}
            isLoading={isInitiallyFetching}
          />
        </motion.div>
      </div>

      {/* Desktop Header */}
      <div className="hidden md:block">
        <div
          className={`dashboard-reset relative min-h-[250px] overflow-hidden bg-[#0a0a0a] ${className}`}
          role="region"
          aria-label="Health data editor header"
        >
          <HeaderBackground blur={30} />
          <HealthDataEditorCard
            categories={categories}
            activeCategory={activeCategory}
            onCategoryClick={handleCategoryClick}
            isLoading={isInitiallyFetching}
          />
        </div>
      </div>
    </>
  );
}
